import { createElement } from 'react'

const DangerouslySetInnerElement = ({ rawHTML = '', wrapperTag = 'div' }) => {
  // reference: https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml

  // the rawHTML string may contain some special symbols like &quot; &middot; etc
  return createElement(wrapperTag, {
    dangerouslySetInnerHTML: { __html: rawHTML },
  })
}

export default DangerouslySetInnerElement
